import React from 'react';
import { users } from 'types';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import useUsersDel from '../hooks/use-users-del';
import DialogForm from 'components/dialog/dialog-form';
import AppFormikInput from 'components/form/formik/input/input';

type TValues = {
    reason: string;
};

const DialogDel = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data?: users.TUsersDetail } & TDialogWrapperComponent) => {
    const [onDel, { isLoading }] = useUsersDel(asyncStatesHandlers);

    if (!data || !data.id) {
        console.error('No ID');
    }

    const initValues: TValues = {
        reason: '',
    };

    return (
        <DialogForm<TValues>
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Confirm User Close'}
            onSubmit={async (values) => {
                const payload = {
                    id: data.id,
                    ...values,
                };
                await onDel(payload);
            }}
            isLoading={isLoading}
            initValues={initValues}
            validate={(values) => {
                let errors: Partial<TValues> = {};

                if (values.reason.length === 0) {
                    errors.reason = 'Required';
                }

                return errors;
            }}
        >
            <AppFormikInput name={'reason'} placeholder={'Close reason'} />
        </DialogForm>
    );
};

export default DialogDel;
